import axios from 'axios';
import Feature from '../entity/feature.entity';

export default class FeatureService {
  public static getFeatures(businessUnitId : string): Promise<Feature[]> {
    return axios.get(`/api/v1/${businessUnitId}/features`)
      .then((response: any) => Feature.ofList(response.data));
  }

  public static create(feature: Feature): Promise<Feature> {
    return axios
      .post(`/api/v1/${feature.businessUnitId}/features`, feature)
      .then((response: any) => Feature.of(response.data));
  }
}
